var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconAsking = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { d: "M24.7,14.5c0,1.4-0.3,2.8-1,4.1c-1.6,3.1-4.7,5.1-8.2,5.1\n\tc-1.4,0-2.8-0.3-4.1-1l-6.2,2.1l2.1-6.2c-0.6-1.3-1-2.7-1-4.1c0-3.5,2-6.7,5.1-8.2c1.3-0.6,2.7-1,4.1-1h0.5c4.7,0.3,8.4,4,8.7,8.7\n\tL24.7,14.5L24.7,14.5z" }),
            React.createElement("path", { d: "M12.6,11.6c0.5-1.3,1.9-2.1,3.3-1.6c1,0.4,1.7,1.3,1.7,2.4c0,1.7-2.6,2.6-2.6,2.6" }),
            React.createElement("path", { d: "M15.1,18.9L15.1,18.9" }))));
});
export default IconAsking;
//# sourceMappingURL=IconAsking.js.map